import { render, staticRenderFns } from "./QrCode4.vue?vue&type=template&id=83303b12&scoped=true&"
import script from "./QrCode4.vue?vue&type=script&lang=js&"
export * from "./QrCode4.vue?vue&type=script&lang=js&"
import style0 from "./QrCode4.vue?vue&type=style&index=0&id=83303b12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83303b12",
  null
  
)

export default component.exports